import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import './HomePage.css';

const HomePage = ({ onNavigate }) => {
  const [selectedLocation, setSelectedLocation] = useState('');
  const [showLocationSelection, setShowLocationSelection] = useState(false);
  const [showLocationError, setShowLocationError] = useState(false);

  const locations = [
    { id: 'rajinder_nagar', name: 'Rajinder Nagar' },
    { id: 'patel_nagar', name: 'Patel Nagar' }
  ];

  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
    setShowLocationError(false);
    // Go directly to locker selection without confirmation
    if (onNavigate) {
      onNavigate('lockerselection', location);
    }
  };

  const handleDropOffClick = () => {
    setShowLocationSelection(true);
  };

  const handlePickupClick = () => {
    // For pickup, we don't need location selection - it will be handled in the form
    if (onNavigate) {
      onNavigate('pickup', 'rajinder_nagar'); // Default location, will be handled in form
    }
  };



  const handleAdminAccess = () => {
    if (onNavigate) {
      onNavigate('admin');
    }
  };

  const handleBackToActions = () => {
    setShowLocationSelection(false);
    setSelectedLocation('');
    setShowLocationError(false);
  };

  return (
    <div className="homepage">
      <Header />
      
      <div className="staff-access-corner">
        <button
          className="staff-access-btn"
          onClick={handleAdminAccess}
        >
          👨‍💼 Staff
        </button>
      </div>
      
      <div className="homepage-container">
        <div className="brand-section">
          <h1 className="brand-title">Locker System</h1>
          <p className="brand-tagline">Smart Laundry Management</p>
        </div>
        
        {!showLocationSelection ? (
          <div className="action-section">
            <h2>What would you like to do?</h2>
            <div className="action-buttons">
                             <button
                 className="action-btn dropoff-btn"
                 onClick={handleDropOffClick}
               >
                 🧺 Drop Dirty Clothes
               </button>
                             <button
                 className="action-btn pickup-btn"
                 onClick={handlePickupClick}
               >
                 📦 Collect Ready Orders
               </button>
            </div>
          </div>
        ) : (
          <div className="location-section">
            <button className="back-btn" onClick={handleBackToActions}>
              ← Back
            </button>
            <h2>Select Your Location</h2>
            <div className="location-buttons">
              {locations.map((location) => (
                <button
                  key={location.id}
                  className={`location-btn ${selectedLocation === location.id ? 'selected' : ''}`}
                  onClick={() => handleLocationSelect(location.id)}
                >
                  📍 {location.name}
                </button>
              ))}
            </div>
            {showLocationError && (
              <p className="error-message">⚠️ Please select a location first!</p>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default HomePage; 